class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this.setEls();
    this.setImagesLoaded();
    this.setData();
    this.listeners();
  }

  setEls() {
    this.cardEl = this.closest('[data-product-card]');
    this.quickaddEl = this.closest('quickadd-modal');
    this.els = this.querySelectorAll('[data-swatch-item]');

    if (!this.cardEl || this.quickaddEl) return;

    this.badgeEl = this.cardEl.querySelector('[data-product-card-badge]');
    this.badgePlaceholder = this.cardEl.querySelector('[data-product-card-badge-placeholder]');
    this.badgeImageEl = this.cardEl.querySelector('[data-product-card-badge-image]');
    this.imageEls = this.cardEl.querySelectorAll('[data-product-card-image]');
    this.linkEls = this.cardEl.querySelectorAll('[data-product-card-url]');
    this.mediaEl = this.cardEl.querySelector('[data-product-card-media]');
    this.priceCompareEls = this.cardEl.querySelectorAll('[data-product-card-price-compare]');
    this.priceRegularEls = this.cardEl.querySelectorAll('[data-product-card-price-regular]');
    this.titleEls = this.cardEl.querySelectorAll('[data-product-card-title]');
    this.skuEls = this.cardEl.querySelectorAll('[data-product-card-sku]');
    this.colorEls = this.cardEl.querySelectorAll('[data-product-card-color]');
    this.variantEl = this.cardEl.querySelector('[data-product-card-variant-name]');
  }

  setImagesLoaded() {
    this.imagesLoaded = {};
  }

  setData() {
    this.dataActive = null;
    const jsonEl = this.querySelector('[data-swatches-json]');
    if (!jsonEl) return;
    this.data = JSON.parse(jsonEl.textContent);
  }

  listeners() {
    if (!this.data) return;

    this.els.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault()
        if (el.classList.contains('product-swatches__item--active')) return;
        this.updateProduct(el);
      });
    });
  }

  loadingStateBegin() {
    this.cardEl.classList.add('product-card--loading');
  }

  loadingStateEnd(imageLoaded, img) {
    if (imageLoaded) {
      setTimeout(() => {
        this.cardEl.classList.remove('product-card--loading');
      }, 200);
    } else {
      img.onload = () => {
        setTimeout(() => {
          this.cardEl.classList.remove('product-card--loading');
        }, 200);
      }
    }
  }

  updateBadge() {
    // if active variant has no badge image, hide it:
    if (!this.dataActive.badge && this.badgeEl) {
      this.badgeEl.classList.add('hide');
      return;
    }

    // if active variant has a badge image, show it:
    if (this.dataActive.badge && this.badgeEl) {
      if (this.badgeEl.innerText !== this.dataActive.badge) this.badgeEl.innerText = this.dataActive.badge;
      this.badgeEl.classList.remove('hide');
    }

    // if active variant has a badge image, build it:
    if (this.dataActive.badge && !this.badgeEl) {
      this.badgeEl = document.createElement('p');
      this.badgeEl.setAttribute('data-product-card-badge', '');
      this.badgeEl.innerText = this.dataActive.badge;
      this.badgePlaceholder.appendChild(this.badgeEl);
    }

    if (this.badgeEl) {
      const handle = this.dataActive.badge_is_sale ? 'sale' : this.dataActive.badge_handle;
      this.badgeEl.classList = `badge badge--${handle} product-card__badge product-card__badge--${handle}`;
    }
  }

  updateBadgeImage() {
    // if active variant has no badge image, hide it:
    if (!this.dataActive.badgeImage && this.badgeImageEl) {
      this.badgeImageEl.classList.add('hide');
      return;
    }

    // if active variant has a badge image, show it:
    if (this.dataActive.badgeImage && this.badgeImageEl) {
      if (this.badgeImageEl.src !== this.dataActive.badgeImage.src) this.badgeImageEl.src = this.dataActive.badgeImage.src;
      this.badgeImageEl.classList.remove('hide');
      return;
    }

    // if active variant has a badge image, build it:
    if (this.dataActive.badgeImage && !this.badgeImageEl) {
      this.badgeImageEl = document.createElement('img');
      this.badgeImageEl.classList.add('product__badge-image');
      this.badgeImageEl.setAttribute('data-product-card-badge-image', '');
      this.badgeImageEl.ariaHidden = 'true';
      this.badgeImageEl.role = 'presentation';
      this.badgeImageEl.src = this.dataActive.badgeImage.src;
      this.mediaEl.appendChild(this.badgeImageEl);
    }
  }

  updateImages() {
    this.imageEls.forEach((img, index) => {
      const hover = img.closest('[data-product-card-image-holder="hover"]');
      if (!this.dataActive.images[index]) {
        if (hover) {
          hover.classList.add('hide');
        } else {
          img.classList.add('hide');
        }
        return
      } else {
        if (hover) {
          hover.classList.remove('hide');
        } else {
          img.classList.remove('hide');
        }
      }

      const srcEl = img.querySelector('[data-product-card-image-src]');
      const srcsetEl = img.querySelector('[data-product-card-image-srcset]');
      if (srcEl && this.dataActive.images[index]) srcEl.alt = this.dataActive.images[index].alt;
      if (srcEl && this.dataActive.images[index]) srcEl.src = this.dataActive.images[index].src;
      if (srcEl && srcEl.hasOwnProperty('srcset') && this.dataActive.images[index]) srcEl.srcset = this.dataActive.images[index].srcset;
      if (srcsetEl && this.dataActive.images[index]) srcsetEl.srcset = this.dataActive.images[index].srcsetLarge;

      const videoEl = this.cardEl.querySelector('video');
      if (videoEl) videoEl.classList.add('hide');
    });

    if (!this.dataActive.images.length) {
      const img = this.imageEls[0];
      const srcEl = img.querySelector('[data-product-card-image-src]');
      const srcsetEl = img.querySelector('[data-product-card-image-srcset]');
      if (srcEl && window.theme.strings.noImage) srcEl.alt = '';
      if (srcEl && window.theme.strings.noImage) srcEl.src = window.theme.strings.noImage;
      if (srcEl && srcEl.hasOwnProperty('srcset') && window.theme.strings.noImage) srcEl.srcset = window.theme.strings.noImage;
      if (srcsetEl && window.theme.strings.noImage) srcsetEl.srcset = window.theme.strings.noImage;
      img.classList.remove('hide');
      img.setAttribute('style', 'mix-blend-mode: multiply;');
    } else {
      const img = this.imageEls[0];
      img.style.removeProperty('mix-blend-mode');
    }
  }

  updatePrice() {
    if (this.dataActive.priceCompareAtAmount > this.dataActive.priceAmount) {
      this.priceCompareEls.forEach(el => {
        el.innerHTML = this.dataActive.priceCompareAt;
        el.classList.remove('hide');
      });
      this.priceRegularEls.forEach(el => {
        el.innerHTML = this.dataActive.price;
      });
    } else {
      this.priceCompareEls.forEach(el => {
        el.innerHTML = '';
        el.classList.add('hide');
      });
      this.priceRegularEls.forEach(el => {
        el.innerHTML = this.dataActive.price;
      });
    }
  }

  updateProduct(el) {
    const imageEl = el.querySelector('.product-swatches__image-holder');
    el.classList.add('active');
    imageEl.classList.add('loading');

    this.dataActive = this.data[el.dataset.swatchItem];

    if (!this.dataActive) return;

    publish(PUB_SUB_EVENTS.swatchChange, {
      source: this.cardEl && !this.quickaddEl ? 'product-card' : 'product-detail',
      data: this.dataActive,
      url: el.href,
      el: this.cardEl,
    });

    /* update active classes */
    this.querySelector('.product-swatches__item--active')?.classList.remove('product-swatches__item--active');
    el.classList.add('product-swatches__item--active');

    if (!this.cardEl || this.quickaddEl) return;

    const imageLoaded = el.hasAttribute('data-image-loaded');
    let img;

    /* make request for image to end loading state when its loaded */
    if (!imageLoaded) {
      img = new Image();
      if (this.dataActive.images.length) {
        img.src = this.dataActive.images[0].src;
      } else {
        img.src = window.theme.strings.noImage;
      }
      el.setAttribute('data-image-loaded', true);
    }

    if (!imageLoaded) {
      this.loadingStateBegin();
    }

    /* update content */
    this.updateBadge();
    this.updateBadgeImage();
    this.updateImages();
    this.updatePrice();
    this.linkEls.forEach(el => {
      el.href = this.dataActive.url;
      el.title = `View ${this.dataActive.title}`;
    });
    this.titleEls.forEach(el => {
      el.innerText = this.dataActive.website_tile_title_primary.replace(/&lt;br&gt;/g, "\n").replace(/&#39;/g , "\'");
    });
    if (this.skuEls.length && this.dataActive.website_tile_name) {
      this.skuEls.forEach(el => {
        el.innerText = this.dataActive.website_tile_name;
      });
    }
    this.colorEls.forEach(el => {
      el.innerText = this.dataActive.variants[0].option1;
    });
    if (this.variantEl) this.variantEl.innerText = this.dataActive.variantName;

    if (!imageLoaded) {
      this.loadingStateEnd(imageLoaded, img);
    }

    imageEl.classList.remove('loading');
    el.classList.remove('active');
  }
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches);
}
